import { wf } from './state.js';
import { ctx } from './ctx.js';

/* ── Shared member lookup — moved out of coordination.js when Coordination
   Items were retired (2026-09); this helper has always been used well beyond
   coordination items (Threads, checklist items, sheet check-outs, etc). ──── */
export function getMemberName(id) {
  if (!id) return '';
  if (ctx.membersCache) {
    for (var i = 0; i < ctx.membersCache.length; i++) {
      if (ctx.membersCache[i].id === id) return ctx.membersCache[i].name;
    }
  }
  for (var j = 0; j < ctx.teamContacts.length; j++) {
    if (ctx.teamContacts[j].id === id) return ctx.teamContacts[j].name;
  }
  return id;
}

/* ── Date / number formatters ────────────────────────────────────────────── */
export function fmt(d) {
  if (!d) return '';
  var p = d.split('-');
  var mo = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return mo[parseInt(p[1])-1] + ' ' + parseInt(p[2]);
}

export function daysFrom(d) {
  if (!d) return null;
  var p = d.split('-');
  var t = new Date(parseInt(p[0]), parseInt(p[1])-1, parseInt(p[2]));
  var n = new Date(); n.setHours(0,0,0,0);
  return Math.round((t - n) / 86400000);
}

export function money(n) {
  if (!n && n !== 0) return '';
  return '$' + parseFloat(n).toLocaleString('en-US', {minimumFractionDigits:0, maximumFractionDigits:0});
}

export function todayStr() {
  var d = new Date();
  return d.getFullYear() + '-' + ('0'+(d.getMonth()+1)).slice(-2) + '-' + ('0'+d.getDate()).slice(-2);
}

/* ── String / name helpers ──────────────────────────────────────────────── */
export function initials(name) {
  if (!name) return '?';
  var p = name.trim().split(' ');
  return p.length >= 2 ? (p[0][0]+p[p.length-1][0]).toUpperCase() : name.substring(0,2).toUpperCase();
}

// "Matthew Gibson" -> "Matthew G." (first name + last initial).
export function firstNameLastInitial(name) {
  if (!name) return '';
  var p = name.trim().split(/\s+/);
  return p.length === 1 ? p[0] : p[0] + ' ' + p[p.length - 1][0].toUpperCase() + '.';
}

export function getFirst(v) {
  if (!v) return '';
  return Array.isArray(v) ? (v[0]||'') : v;
}

export function hlText(text, q) {
  if (!q || !text) return text;
  var idx = text.toLowerCase().indexOf(q.toLowerCase());
  if (idx === -1) return text;
  return text.slice(0, idx)
    + '<mark style="background:#fff3a3;border-radius:2px;padding:0 1px;">'
    + text.slice(idx, idx + q.length)
    + '</mark>'
    + text.slice(idx + q.length);
}

/* ── Inline SVGs ────────────────────────────────────────────────────────── */
export function ckSvg(c) {
  return '<svg width="10" height="10" viewBox="0 0 14 14" fill="none"><polyline points="2,7.5 5.5,11 12,3" stroke="'+(c||'white')+'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
}

export function lkSvg() {
  return '<svg width="11" height="11" viewBox="0 0 16 16" fill="none"><rect x="3" y="7" width="10" height="8" rx="1.5" stroke="#b8540a" stroke-width="1.4"/><path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2" stroke="#b8540a" stroke-width="1.4" stroke-linecap="round"/></svg>';
}

/* ── Node key builders ──────────────────────────────────────────────────── */
export function phKey(phId)          { return 'ph:' + phId; }
export function msKey(msId)          { return 'ms:' + msId; }
export function catKey(msId, cat)    { return 'cat:' + msId + ':' + cat; }
export function itemKey(itemId)      { return 'item:' + itemId; }
export function sectionKey(msId, type)     { return 'sec:' + msId + ':' + type; }
export function rootSectionKey(name)       { return 'root:' + name; }

/* ── Collapse state ─────────────────────────────────────────────────────── */
export function isNodeCollapsed(key, defaultCollapsed) {
  if (wf.searchQuery && wf._searchExpanded && wf._searchExpanded[key]) return false;
  if (defaultCollapsed === undefined) return !!wf.collapsed[key];
  return wf.collapsed[key] !== false;
}

/* ── Toast pill ─────────────────────────────────────────────────────────── */
export function showPill(msg, isErr) {
  var el = document.getElementById('aj-sc-spill');
  if (!el) return;
  el.textContent = msg;
  el.className = 'aj-sc-save-pill visible' + (isErr ? ' err' : '');
  clearTimeout(el._pillTimer);
  el._pillTimer = setTimeout(function() {
    el.className = 'aj-sc-save-pill' + (isErr ? ' err' : '');
  }, 2500);
}
